// This component is responsible for the header of the site.
// It is responsible for the burger trigger and the login off-canvas.
// It is also responsible for the login message and the login form.
// It is also responsible for the login intro button.

export const initHeader = () => {
  const burgerTrigger = document.querySelector(".brxe-xburgertrigger");
  const loginOffCanvas = document.querySelector(".offcanvas--login");
  const heading = document.querySelector(".login-message");
  const loginForm = document.querySelector('.login-form');
  const loginIntroButton = document.getElementById('login-intro');

  const MODAL_ID = "brxe-wlobyfj";

  // Add fallback modal functions if not defined
  const xOpenModal = window.xOpenModal || function(id) {
    const modal = document.getElementById(id);
    if (modal) {
      modal.style.display = 'block';
      modal.setAttribute('aria-hidden', 'false');
    }
  };

  const xCloseModal = window.xCloseModal || function(id) {
    const modal = document.getElementById(id);
    if (modal) {
      modal.style.display = 'none';
      modal.setAttribute('aria-hidden', 'true');
    }
  };

  let loginMessage = sessionStorage.getItem("login-message");
  let isModalTransitioning = false;
  let currentModalState = false; // Track actual modal state

  // Handle burger trigger
  if (burgerTrigger) {
    let lastClickTime = 0;
    const DEBOUNCE_TIME = 300; // Minimum time between clicks
    let isProcessing = false;

    const handleToggle = (e) => {
      e.preventDefault();

      const now = Date.now();
      if (now - lastClickTime < DEBOUNCE_TIME || isProcessing) return;
      lastClickTime = now;
      isProcessing = true;

      const modal = document.getElementById(MODAL_ID);
      if (!modal) {
        isProcessing = false;
        return;
      }

      // Get actual state from modal
      const isOpen = modal.getAttribute('aria-hidden') === 'false';

      // Force sync modal state with button state
      burgerTrigger.setAttribute('aria-expanded', !isOpen);

      if (isOpen) {
        xCloseModal(MODAL_ID);
      } else {
        xOpenModal(MODAL_ID);
      }

      // Reset processing flag after animation
      setTimeout(() => {
        isProcessing = false;
      }, 300); // Match this with your actual animation duration
    };

    burgerTrigger.addEventListener("click", handleToggle);

    // Cleanup function
    return () => {
      burgerTrigger.removeEventListener("click", handleToggle);
    };
  }

  // Handle login message and off-canvas events
  if (loginOffCanvas && heading) {
    const updateLoginMessage = () => {
      loginMessage = sessionStorage.getItem("login-message");
      if (loginMessage) {
        heading.innerHTML = loginMessage;
        heading.classList.remove("is-hidden");
      }
    };

    updateLoginMessage(); // Initial check

    loginOffCanvas.addEventListener("x_offcanvas:open", updateLoginMessage);

    loginOffCanvas.addEventListener("x_offcanvas:close", () => {
      heading.classList.add("is-hidden");
      heading.innerHTML = ''; // Clear stale message
      sessionStorage.removeItem("login-message");
    });
  }

  // Handle login form redirect
  if (loginForm?.contains(loginIntroButton)) {
    const loginFormRedirectField = loginForm.querySelector('[data-custom-id="redirect"][type="hidden"]');
    if (loginFormRedirectField) {
      loginIntroButton.addEventListener('click', () => {
        loginFormRedirectField.value = `${window.location.href}?register`;
      });
    }
  }
};
